import React from "react";
import { useTranslation } from "react-i18next";

function PrivateDonation() {
  const { t, i18n } = useTranslation();
  const langParam = i18n.language && i18n.language.startsWith("de") ? "de" : "en";

  return (
    <section className="pt-12 pb-12 bg-white dark:bg-slate-800 transition-colors relative z-10" id="private-donation">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="mb-8 text-center">
          <h2 className="text-4xl md:text-5xl mb-5 text-primary dark:text-primary-light relative inline-block">
            {t("donations.private.title")}
            {/* Underline decoration */}
            <div className="absolute -bottom-2.5 left-1/2 transform -translate-x-1/2 w-15 h-0.5 bg-primary dark:bg-primary-light rounded-sm" />
          </h2>
          <p className="text-slate-600 dark:text-slate-400 mt-4 text-lg max-w-3xl mx-auto">
            {t("donations.private.description")}
          </p>
        </div>

        {/* Donation Widget */}
        <div className="flex justify-center">
          <iframe
            title="Betterplace Spenden-Widget"
            src={`https://project-widget.betterplace.org/projects/157400?l=${langParam}`}
            width="280"
            height="320"
            frameBorder="0"
            marginHeight={0}
            marginWidth={0}
            className="border-0"
            style={{ display: 'block' }}
          ></iframe>
        </div>
      </div>
    </section>
  );
}

export default PrivateDonation;

